<ng-container *ngIf="!!data; else noData">
  <section>
    <h3>Preisdaten</h3>
    <table mat-table [dataSource]="data.positions" class="mat-elevation-z2" style="width: 100%">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Beschreibung</th>
        <td mat-cell *matCellDef="let position">{{ position.name }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Preis</th>
        <td mat-cell *matCellDef="let position">{{ position.amount }}€</td>
      </ng-container>

      <ng-container matColumnDef="tax">
        <th mat-header-cell *matHeaderCellDef>Steuersatz</th>
        <td mat-cell *matCellDef="let position">{{ position.tax }}%</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['name', 'amount', 'tax']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 'amount', 'tax']"></tr>
    </table>
  </section>
  <section>
    <div class="summary-section" *ngIf="data?.positions?.length > 0">
      <div class="summary-row">
        <span>Netto-Summe:</span>
        <span>{{ priceCalculation.totalPriceNetto | currency : 'EUR' }}</span>
      </div>
      <div class="summary-row" *ngFor="let taxGroup of priceCalculation.mwstGrouped">
        <span>MwSt. ({{ taxGroup.percentage }}%):</span>
        <span>{{ taxGroup.amount | currency : 'EUR' }}</span>
      </div>
      <div class="summary-row total">
        <span>Brutto-Summe:</span>
        <span>{{ priceCalculation.totalPriceBrutto | currency : 'EUR' }}</span>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #noData>
  <p>Keine Daten vorhanden</p>
</ng-template>
